// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2bSiS","signatureBlock":"Footer_signatureBlock__3Yt-l","signature":"Footer_signature__6TPO6"};